import { FC } from 'react'
import { EmbedType, MessageItem_ChatMessageFragment } from 'generated/graphql'
import CbtExamMessage from './CbtExamMessage'
import TeamRecruitMessage from './TeamRecruitMessage'

interface MessageContentProps {
  embedData: MessageItem_ChatMessageFragment['embedData']
  content: string
  viewerIsSender: boolean
}

const MessageContent: FC<MessageContentProps> = ({
  embedData,
  content,
  viewerIsSender,
}) => {
  switch (embedData?.embedType) {
    case EmbedType.CBT_EXAM:
      return (
        <CbtExamMessage embedData={embedData} viewerIsSender={viewerIsSender} />
      )
    case EmbedType.TEAM_RECRUIT:
      return (
        <TeamRecruitMessage
          embedData={embedData}
          viewerIsSender={viewerIsSender}
        />
      )
    default:
      return <p className="message-content">{content}</p>
  }
}

export default MessageContent
